import { User } from '@/types';

export const demoUsers: User[] = [];